import { Injectable, inject } from '@angular/core';
import { ConfigService, DataService } from '@shared/services';

@Injectable({
  providedIn: 'root',
})
export class LenderHubDataService extends DataService {
  public constructor() {
    const configService = inject(ConfigService);
    super(configService.config?.lenderHubApiUrl ?? '');
  }
}
